import React from "react";
import "./RelatorioCalibracaoPrensaSolosPrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import { LOGO_MARCA_DAGUA, NOME_CLIENTE_DOCUMENTO } from "../Config/branding";

function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  if (typeof dataISO === "string" && dataISO.includes("-")) {
    const [ano, mes, dia] = dataISO.split("-");
    return `${dia}/${mes}/${ano}`;
  }
  return dataISO;
}

function numeroBR(valor, casas = 2) {
  if (valor === null || valor === undefined || valor === "" || valor === "-") return "-";
  const numero = Number(String(valor).replace(",", "."));
  if (Number.isNaN(numero)) return valor;
  return numero.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas
  });
}

function obterNumeroCodigo(dados = {}) {
  const codigo = String(dados.codigo || "").trim();
  const match = codigo.match(/RE-CAL-SOLOS\s*-\s*(\d+)/i) || codigo.match(/(\d{3,})/);
  return (match?.[1] || match?.[0] || "0").replace(/\D/g, "").padStart(4, "0");
}

function imprimirPreview() {
  const styleId = "print-style-calibracao-prensa-solos";
  let style = document.getElementById(styleId);

  if (!style) {
    style = document.createElement("style");
    style.id = styleId;
    style.media = "print";
    style.textContent = "@page { size: A4 portrait; margin: 5mm; }";
    document.head.appendChild(style);
  }

  const limpar = () => {
    document.getElementById(styleId)?.remove();
    window.removeEventListener("afterprint", limpar);
  };

  window.addEventListener("afterprint", limpar);
  window.print();
}

export default function RelatorioCalibracaoPrensaSolosPrint({ dados = {}, onVoltar }) {
  const resultados = Array.isArray(dados.resultados) ? dados.resultados : [];
  const numeroCodigo = obterNumeroCodigo(dados);
  const ano = String(dados.dataCalibracao || dados.data || "").slice(0, 4) || new Date().getFullYear();
  const codigo = dados.codigo || `RE-CAL-SOLOS - ${numeroCodigo}/${ano}`;
  useNomeArquivoPdf(onVoltar ? codigo : "");
  const tipoEquipamento =
  dados.tipoEquipamento ||
  "Máquina de ensaios por compressão";

  return (
    <div className="relatorio-calibracao-solos-print">
      {onVoltar && (
        <div className="acoes-print-solos">
          <button onClick={onVoltar} className="btn-voltar-solos">Voltar</button>
          <button onClick={imprimirPreview} className="btn-imprimir-solos">Imprimir</button>
        </div>
      )}

      <div
  className="pagina-calibracao-solos"
  style={{
    "--marca-dagua-solos": `url("${LOGO_MARCA_DAGUA}")`
  }}
>
        <header className="cabecalho-solos">
          <div className="marca-solos">
            <LogoRelatorio alt="Logo da empresa" variante="calibracao-prensa" />
            <div>
              <strong>{NOME_CLIENTE_DOCUMENTO.toUpperCase()}</strong>
              <span>Sistema de gestão da qualidade</span>
            </div>
          </div>
          <div className="documento-solos">
            <span>Certificado de calibração</span>
            <strong>{codigo}</strong>
          </div>
        </header>

        <section className="titulo-solos">
          <h1>Calibração de prensa de CBR / Marshall</h1>
          <p>Relatório técnico de verificação metrológica para ensaios de solos e pavimentação.</p>
        </section>

        <section className="grid-info-solos">
          <div><span>Cliente</span><strong>{dados.empresa || "-"}</strong></div>
          <div><span>Empreendimento</span><strong>{dados.obra || "-"}</strong></div>
          <div><span>Local</span><strong>{dados.local || dados.endereco || "-"}</strong></div>
          <div><span>Data da calibração</span><strong>{formatarDataBR(dados.dataCalibracao || dados.data)}</strong></div>
          <div><span>Validade</span><strong>{dados.validade || "-"}</strong></div>
          <div><span>Vencimento</span><strong>{formatarDataBR(dados.dataVencimento)}</strong></div>
        </section>

       <section className="bloco-solos">
 <h2>Equipamento calibrado</h2>

  <div className="grid-detalhes-solos">
    <div>
      <span>Tipo</span>
      <strong>
        {dados.tipoEquipamento ||
          "Máquina de ensaios por compressão"}
      </strong>
    </div>

    <div>
      <span>Marca</span>
      <strong>{dados.marca || "-"}</strong>
    </div>

    <div>
      <span>Extensômetro</span>
      <strong>{dados.extensometro || "-"}</strong>
    </div>

    <div>
      <span>Resol. extensômetro</span>
      <strong>{dados.resolucaoExtensometro || "-"}</strong>
    </div>

    <div>
      <span>Especificação</span>
      <strong>{dados.especificacao || "-"}</strong>
    </div>

    <div>
      <span>Número de série</span>
      <strong>{dados.numeroSerie || "-"}</strong>
    </div>

    <div>
      <span>Anel</span>
      <strong>{dados.anel || "-"}</strong>
    </div>

    <div>
      <span>Capacidade</span>
      <strong>{dados.capacidade || "-"}</strong>
    </div>
  </div>
</section>

        <section className="bloco-solos">
          <h2>Resultados</h2>
          <table className="tabela-resultados-solos">
            <thead>
              <tr>
                <th rowSpan="2">Carga aplicada<br />(padrão)</th>
                <th colSpan="3">
                  DEFORMAÇÃO DO ANEL DINAMOMÉTRICO
                  <br />
                  <span>(valores em {dados.unidadeLeitura || "microns"})</span>
                </th>
              </tr>
              <tr>
                <th>LEITURA 1</th>
                <th>LEITURA 2</th>
                <th>MÉDIA</th>
              </tr>
            </thead>
            <tbody>
              {resultados.map((item, index) => (
                <tr key={`${item.carga}-${index}`}>
                  <td>{numeroBR(item.carga, 0)}</td>
                  <td>{numeroBR(item.l1, 1)}</td>
                  <td>{numeroBR(item.l2, 1)}</td>
                  <td>{numeroBR(item.media, 1)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="duas-colunas-solos">
          <div className="bloco-solos">
            <h2>Parâmetros CBR / Marshall</h2>
            <table className="tabela-parametros-solos">
              <tbody>
                <tr><td>Constante Marshall</td><td>{dados.constanteMarshall || "-"}</td></tr>
                <tr><td>Constante C.B.R.</td><td>{dados.constanteCbr || "-"}</td></tr>
                <tr><td>Diâmetro do pistão</td><td>{dados.diametroPistao || "-"}</td></tr>
                <tr><td>Área</td><td>{dados.areaPistao || "-"}</td></tr>
              </tbody>
            </table>
          </div>

          <div className="bloco-solos">
            <h2>Padrão utilizado</h2>
            <p>
              {dados.identificacaoPadrao || dados.padraoEquipamentoNome || "-"}
              {dados.certificadoPadrao ? `, certificado ${dados.certificadoPadrao}` : ""}.
            </p>
            <p>
              Calibração realizada conforme procedimento interno aplicável e rastreabilidade
              informada no padrão selecionado.
            </p>
          </div>
        </section>

        <section className="bloco-solos observacao-solos">
          <h2>Observações</h2>
          <p>{dados.observacao || "Os resultados apresentados neste certificado têm significação restrita e referem-se exclusivamente ao equipamento calibrado."}</p>
        </section>

        <footer className="rodape-solos">
          <div>
            <span>Técnico responsável</span>
            <img src="/Images/assinaturaLeal.png" alt="Assinatura" />
            <strong>Jose Carlos Lemes Leal</strong>
            <small>Eng. Civil Esp. CREA 203379/D-TO</small>
          </div>
          <p>Documento para uso restrito. Reprodução proibida sem autorização da empresa.</p>
        </footer>
      </div>
    </div>
  );
}
